import { IEventBlueprintDTO } from '../../../../api/blueprints/event.blueprint.types';
import { withViewModel } from '../../../../infrastructure/components/with-view-model';
import { OrderBookingEventBlueprintsFormVM } from './order-booking-event-blueprint-form.viewmodel';
import { OrderBookingEventBlueprintFormPresentation } from './order-booking-event-blueprint-from.presentation';


type OrderBookingEventBlueprintFormProps = {
    blueprint?: IEventBlueprintDTO;
    accountId: number;
    formSubmitAction: (blueprint: IEventBlueprintDTO) => Promise<IEventBlueprintDTO>;
};

export const OrderBookingEventBlueprintForm = withViewModel(OrderBookingEventBlueprintFormPresentation, (props: OrderBookingEventBlueprintFormProps) => {
    const {
        blueprint,
        accountId,
        formSubmitAction
    } = props;
    const vm = new OrderBookingEventBlueprintsFormVM(
        blueprint,
        accountId,
        formSubmitAction,
    );

    return vm;
}, () => [],);